import { schema } from 'normalizr'

const deliveryProduct = new schema.Entity('deliveryProducts', {})

export default deliveryProduct
